import { ButtonProps } from '@mui/material/Button'
import { ReactNode } from 'react'

import { Link, TabButton } from './MenuTab.styles'

export function MenuTab({
  label,
  icon,
  open,
  to,
  ...props
}: { label: string; icon: ReactNode; open: boolean; to: string } & ButtonProps) {
  return (
    <Link to={to}>
      <TabButton label={open ? label : undefined} startIcon={icon} open={open} {...props} />
    </Link>
  )
}
